/**
 * 报表生成记录
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XDatePicker, XCancelButton } from '@/components/xqxc_ui';
import model from '@/reducers/report/reportrecord/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableActionType as ta } from '@/util/enum';
import { message } from 'antd';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        templateName: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match);
    }

    // 查询
    _searchHandle = (useCache) => {
        const { templateName, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            templateName,
            gmtCreateStart: startTime,
            gmtCreateEnd: endTime,

            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ templateName: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        switch (type) {
            case ta.edit:
                this.props.history.push({ pathname: `/home/report/reportrecord/${ta.edit}/${key}` });
                break;
            case ta.link:
                if (item.downloadUrl) {
                    const regular = /(http|https):\/\/([\w.]+\/?)\S*/;
                    regular.test(item.downloadUrl)
                        ? (location.href = item.downloadUrl, message.success('导出成功'))
                        : message.warning('路径无效');
                } else {
                    message.warning('暂无数据');
                }
                break;
        }
    }

    // 生成报表
    _exportInfo = () => {
        this.props.history.push({ pathname: `/home/report/reportrecord/${ta.create}/0` });
    }

    render() {
        const { templateName, startTime, endTime } = this.state;
        let { tableSource } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 200 }}
                                label='报表名称'
                                placeholder='请输入'
                                value={templateName}
                                bindThis={this}
                                bindName='templateName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='生成日期'
                                datePickerStyle={{ width: 200 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                defaultTime='00:00:00'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 200 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                defaultTime='23:59:59'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.row2}>
                        <XOKButton
                            style={{ width: 100, marginRight: 10 }}
                            label='生成报表'
                            onClick={this._exportInfo}
                        />
                    </div>
                    <TableList
                        renderData={tableSource}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,

    getTableSource: PropTypes.func,
    tableSource: PropTypes.object,
};
const mapStateToProps = (state) => ({
    tableSource: state.reportrecord.tableSource,
});

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);